import { render, staticRenderFns } from "./RightBottom.vue?vue&type=template&id=012b65d6&scoped=true"
import script from "./RightBottom.vue?vue&type=script&lang=js"
export * from "./RightBottom.vue?vue&type=script&lang=js"
import style0 from "./RightBottom.vue?vue&type=style&index=0&id=012b65d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b65d6",
  null
  
)

export default component.exports